import { faHome, faSignOutAlt, faStoreAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown, { DropdownPlacement } from '@ui/Dropdown';
import useAuth from 'hooks/useAuth';
import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import { Key, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { buildAbsoluteLink } from '~/lib/links';
import { Button } from '../ui';

interface Props {
    placement?: DropdownPlacement;
}

export const UserDropdown = ({ placement }: Props) => {
    const { t } = useTranslation('auth');
    const { user, logout } = useAuth();
    const clubs = user?.clubs || [];
    const router = useRouter();
    const asPath = usePathname();
    const [imageError, setImageError] = useState(false);

    useEffect(() => {
        setImageError(false);
    }, [user?.image]);

    const handleDropdownEvent = (e: Key) => {
        switch (e) {
            case 'logout':
                logout();
                break;

            case 'home':
                router.push(buildAbsoluteLink('/home'));
                break;

            default: {
                if (String(e).startsWith('locale:')) {
                    // @ts-ignore
                    router.push(asPath, { locale: String(e).split(':')[1] });
                    return;
                }

                router.push(buildAbsoluteLink(`/club/${e}`));
                break;
            }
        }
    };

    const avatarSrc = user?.image && !imageError ? `${process.env.NEXT_PUBLIC_API_HOST}image/${user.image}` : null;

    return (
        <Dropdown
            placement={placement}
            label="Dashboard"
            icon={<FontAwesomeIcon icon={faHome} />}
            triggerElement={
                <Button
                    color="secondary"
                    flat
                    className="tw-h-15 tw-relative tw-aspect-square !tw-rounded-full tw-overflow-hidden tw-border-2 tw-border-accents-8/40 tw-bg-transparent !tw-p-2 !tw-py-4"
                    aria-label="Open user menu"
                >
                    {avatarSrc ? (
                        <Image
                            src={avatarSrc}
                            alt="User avatar"
                            layout="fill"
                            className="tw-h-full tw-w-full tw-object-cover"
                            onError={() => setImageError(true)}
                        />
                    ) : (
                        <FontAwesomeIcon icon={faHome} />
                    )}
                </Button>
            }
        >
            <Dropdown.Item
                key="home"
                icon={<FontAwesomeIcon icon={faHome} />}
                label="Dashboard"
                onClick={() => handleDropdownEvent('home')}
            />
            {clubs.length > 0 &&
                clubs.map((club) => (
                    <Dropdown.Item
                        label={club.title}
                        key={club.slug}
                        icon={<FontAwesomeIcon icon={faStoreAlt} />}
                        onClick={() => handleDropdownEvent(club.slug)}
                    />
                ))}
            <Dropdown.Item
                label={t('Ausloggen')}
                icon={<FontAwesomeIcon icon={faSignOutAlt} />}
                color="error"
                onClick={() => handleDropdownEvent('logout')}
            />
        </Dropdown>
    );
};
